// A question a chat puts to the person, answered on a card in the transcript
// (components/ChatQuestionCard.jsx): pick any number of the choices, ask for
// other options, or answer in their own words. Any chat can offer the tool; what
// "other options" should lean towards is that chat's own instruction.
import { Type } from "@earendil-works/pi-ai";

export const QUESTION_KIND = "operatorQuestion";
// A pick is sent back as the choice's own text, so a choice is kept whole; the
// cap only stops a runaway one.
const CHOICE_MAX = 200;
const QUESTION_MAX = 200;
const CHOICES_MAX = 5;

const str = (v) => (v == null ? "" : String(v));
const clip = (s, n) => {
    const t = str(s).replace(/\s+/g, " ").trim();
    return t.length > n ? `${t.slice(0, n - 3)}...` : t;
};

// The person's answer from their picks, each choice in full: one alone, several
// as a list.
export function answerFrom(picks) {
    return picks.length === 1 ? picks[0] : picks.map((p) => `- ${p}`).join("\n");
}

// What asking for other options sends, keeping any picks already made.
export function otherOptionsFrom(picks) {
    if (!picks.length) return "None of these fit. Show me other options.";
    return `Keep ${picks.length === 1 ? "this" : "these"}:\n${picks.map((p) => `- ${p}`).join("\n")}\nAnd show me other options.`;
}

export function createAskTool() {
    return {
        name: "ask_operator",
        label: "Question",
        description: "Ask the person one question with a few choices. They can pick any number of them (so never offer 'All of the above'), ask for other options, or answer in their own words. Their answer comes back as the choices' text. When they ask for other options, ask again with different choices that do not repeat earlier ones. End your turn after calling this and wait for the answer.",
        parameters: Type.Object({
            question: Type.String({ description: "one short question" }),
            choices: Type.Array(Type.String(), { description: `two to ${CHOICES_MAX} answers, each under 60 characters so the buttons read at a glance` }),
        }),
        async execute(_id, args) {
            const question = clip(args?.question, QUESTION_MAX);
            const choices = (Array.isArray(args?.choices) ? args.choices : []).map((c) => clip(c, CHOICE_MAX)).filter(Boolean).slice(0, CHOICES_MAX);
            if (!question) return { content: [{ type: "text", text: "ask_operator needs a question." }], details: { error: "ask_operator needs a question." }, isError: true };
            return { content: [{ type: "text", text: "Asked. End your turn now and wait for the answer." }], details: { kind: QUESTION_KIND, question, choices } };
        },
    };
}
